import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { FornecimentoDireto, FornecimentoDiretoVisaoAnalitica } from '@gestor-web/@core/api/ords/model';
import { Page } from '@gestor-web/app/shared/components';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FornecimentoDiretoService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  fetchData(regans: string, competenciaInicial: string, competenciaFinal: string, pageData: Page) {
    return this.simuladorGoApi
      .fetchFornecimentoDireto({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        page: pageData.page,
        size: pageData.size,
      })
      .pipe(
        map(response => ({
          items: (response.items ?? []) as FornecimentoDireto[],
          total: response.total ?? 0,
        })),
      );
  }

  fetchVisaoAnalitica(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchFornecimentoDiretoVisaoAnalitica({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(map(response => (response.items ?? []) as FornecimentoDiretoVisaoAnalitica[]));
  }

  fetchDetalhes(regans: string, cdGuiaMonitor: string) {
    return this.simuladorGoApi.fetchDetalhesFornecimentoDireto({
      regans,
      cd_guia_monitor: cdGuiaMonitor,
    });
  }
}
